/**
 * /tenants/$slug/non-human-identities/overview: thin route shim. Domain content lives in
 * features/nhi-overview/.
 *
 * No loader. The page is static explanation and fetches nothing, so there is no data to
 * prefetch and no spinner to avoid.
 *
 * NOTE for whoever adds the next child under /non-human-identities: this route is the
 * reason the rail's heading link carries activeOptions exact. Without it the census
 * entry lights up here too, because /non-human-identities is a prefix of
 */

import { createFileRoute } from "@tanstack/react-router";
import { NhiOverviewPage } from "@/features/nhi-overview/pages/nhi-overview-page";

export const Route = createFileRoute("/_authed/tenants/$slug/non-human-identities/overview")({
  component: NhiOverviewPage,
});
